<script setup>
import { computed, onMounted } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';

import WootReports from './components/WootReports.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const store = useStore();
const currentUser = useMapGetter('getCurrentUser');
const getAgentById = useMapGetter('agents/getAgentById');

onMounted(() => store.dispatch('agents/get'));

const agent = computed(() => {
  const currentId = currentUser.value?.id;
  if (!currentId) return null;
  const fromStore = getAgentById.value(currentId);
  return fromStore?.id ? fromStore : currentUser.value;
});
</script>

<template>
  <WootReports
    v-if="agent?.id"
    :key="agent.id"
    type="agent"
    getter-key="agents/getAgents"
    action-key="agents/get"
    :selected-item="agent"
    :show-entity-filter="false"
    :show-download="false"
    :download-button-label="$t('AGENT_REPORTS.DOWNLOAD_AGENT_REPORTS')"
    :report-title="$t('SIDEBAR.REPORTS_OWN')"
  />
  <div v-else class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
</template>
